export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13994.9673d010.jpg";